import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { LanguageService, Language } from '@core/services/language.service';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent {
  languageService = inject(LanguageService);

  // Langues disponibles
  languages = this.languageService.availableLanguages;

  // Code de la langue courante en tant que signal computed
  selectedLanguageCode = computed(() => this.languageService.currentLanguage().code);

  /**
   * Change la langue de l'application
   * @param languageCode Code de la langue selectionnee
   */
  onLanguageChange(languageCode: string): void {
    this.languageService.setLanguage(languageCode);
  }
}
